import { FULL_WIDTH_CHARACTER_OPTION, HALF_WIDTH_CHARACTER_OPTION, JAPANESE_CHARACTER_OPTION } from "@/utils/cp932Validator";
import { validator } from "@/utils/validator";

export const matchSchema = validator.object().shape({
  matchName: validator
    .string()
    .trim()
    .emptyToNull()
    .autoTransformToFullWidth()
    .max(60)
    .isValidCP932Character({ ...HALF_WIDTH_CHARACTER_OPTION, ...FULL_WIDTH_CHARACTER_OPTION, ...JAPANESE_CHARACTER_OPTION })
    .label("名称")
    .required(),
  matchLicenseNumber: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("許可番号").required(),
});
